import React from 'react';
import cx from 'clsx';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { Box, makeStyles, Paper, PaperProps, Theme, Typography } from '@material-ui/core';
import { ReportView } from 'components/ReportsModule/types';
import Popover from 'components/@common/Popover';
import MaybeRenderReportElement, {
  MaybeRenderReportElementProps
} from './MaybeRenderReportElement';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      height: '100%',
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
      boxSizing: 'border-box'
    },
    avoidBreaking: {
      breakInside: 'avoid'
    }
  };
});

interface Props extends PaperProps, MaybeRenderReportElementProps {
  title?: any;
  helpText?: any;
  breakable?: boolean;
  endAdornment?: any;
  titleEndAdornment?: any;
}

const ReportCard: React.FC<Props> = ({
  children,
  title,
  helpText,
  loading,
  reportData,
  reportDataProp,
  titleEndAdornment,
  endAdornment,
  ...props
}) => {
  const classes = useStyles();
  const [{ viewAs }] = useReportQueryParams();
  const titleComponent = <Typography variant="h4">{title}</Typography>;

  const maybeBoxProps = endAdornment && {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  };

  return (
    <Paper
      {...props}
      component="article"
      className={cx(classes.container, {
        [classes.avoidBreaking]: viewAs === ReportView.CHART
      })}
    >
      <Box {...maybeBoxProps}>
        <Box {...(titleEndAdornment && { display: 'flex', alignItems: 'center' })}>
          {helpText ? <Popover description={helpText}>{titleComponent}</Popover> : titleComponent}
          {titleEndAdornment}
        </Box>
        {endAdornment}
      </Box>
      <MaybeRenderReportElement
        loading={loading}
        reportData={reportData}
        reportDataProp={reportDataProp}
      >
        {children}
      </MaybeRenderReportElement>
    </Paper>
  );
};

export default ReportCard;
